import React from "react";
import { translation } from "./Translation";

const ChevronIcon = () => (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
      fill="#8C8C8C"
    />
  </svg>
);

const ProductFilterModal = ({
  lang = "fa",
  showFilterTab,
  setShowFilterTab,
  showInventory,
  setShowInventory,
  catList,
  brandList,
  shopCatList,
  subcategoryList,
  warehouseList,
  selectedCat,
  selectedBrand,
  subCat,
  selectedSubcategory,
  selectedWarehouse,
  onCategorySelect,
  onBrandSelect,
  onSubCatSelect,
  onSubcategorySelect,
  onWarehouseSelect,
  onApply,
  onClose,
}) => {
  const toggleTab = (tab) => {
    setShowFilterTab(showFilterTab !== tab ? tab : 0);
  };

  return (
    <div id="filter_modal" className="filter-modal">
      <div className="filter-modal-head" />
      <h2>
        <svg
          onClick={onClose}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M21 7L11 7" stroke="#3BA7E4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
            stroke="#3BA7E4"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path d="M3 17L13 17" stroke="#3BA7E4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
            stroke="#3BA7E4"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
        {translation.Products_filter[lang] ? translation.Products_filter[lang] : "فیلتر"}
      </h2>
      <button
        id="show_invent_btn"
        onClick={() => setShowInventory(!showInventory)}
        className={showInventory ? "inventory-tbn to-center-btn" : "inventory-tbn "}
      >
        <span className="btn-in">
          <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3.5" cy="3.5" r="3.5" fill="#979797" />
          </svg>
          {translation.Products_available[lang]
            ? translation.Products_available[lang]
            : "فقط کالا های موجود"}
        </span>
      </button>
      <button onClick={() => toggleTab(1)} className="filter-btn">
        {translation.Products_Select[lang] ? translation.Products_Select[lang] : "انتخاب دسته بندی"}
        <ChevronIcon />
      </button>
      <div id="filter_tab_1" className={showFilterTab !== 1 ? "filter-items" : "filter-items show"}>
        {catList?.map((item) => (
          <button
            onClick={() => onCategorySelect(item.id)}
            key={item.id}
            className={item.id == selectedCat && "bg-info"}
          >
            {item.title}
          </button>
        ))}
      </div>
      <button onClick={() => toggleTab(4)} className="filter-btn" disabled={!selectedCat}>
        {translation.Products_Subcategory?.[lang] || "انتخاب زیر دسته"}
        <ChevronIcon />
      </button>
      <div id="filter_tab_4" className={showFilterTab !== 4 ? "filter-items" : "filter-items show"}>
        {subcategoryList.length === 0 ? (
          <span className="filter-empty-hint">
            {selectedCat ? "زیردسته‌ای برای این دسته یافت نشد" : "ابتدا دسته‌بندی اصلی را انتخاب کنید"}
          </span>
        ) : (
          subcategoryList.map((item) => (
            <button
              onClick={() => onSubcategorySelect(item.id)}
              key={item.id}
              className={item.id == selectedSubcategory && "bg-info"}
            >
              {item.title}
            </button>
          ))
        )}
      </div>
      <button onClick={() => toggleTab(2)} className="filter-btn">
        {translation.Products_Brand[lang] ? translation.Products_Brand[lang] : "انتخاب برند"}
        <ChevronIcon />
      </button>
      <div id="filter_tab_2" className={showFilterTab !== 2 ? "filter-items" : "filter-items show"}>
        {brandList?.map((item) => (
          <button
            className={item.id == selectedBrand && "bg-info"}
            onClick={() => onBrandSelect(item.id)}
            key={item.id}
          >
            {item.name}
          </button>
        ))}
      </div>
      <button onClick={() => toggleTab(3)} className="filter-btn">
        {translation.Products_Internal[lang]
          ? translation.Products_Internal[lang]
          : "انتخاب دسته بندی داخلی"}
        <ChevronIcon />
      </button>
      <div id="filter_tab_3" className={showFilterTab !== 3 ? "filter-items" : "filter-items show"}>
        {shopCatList?.map((item) => (
          <button
            onClick={() => onSubCatSelect(item.id)}
            key={item.id}
            className={item.id == subCat && "bg-info"}
          >
            {item.title}
          </button>
        ))}
      </div>
      <button onClick={() => toggleTab(5)} className="filter-btn">
        {translation.Products_Warehouse?.[lang] || "انتخاب انبار"}
        <ChevronIcon />
      </button>
      <div id="filter_tab_5" className={showFilterTab !== 5 ? "filter-items" : "filter-items show"}>
        {warehouseList.length === 0 ? (
          <span className="filter-empty-hint">انباری برای ویزیتور تعریف نشده</span>
        ) : (
          warehouseList.map((item) => (
            <button
              onClick={() => onWarehouseSelect(item.id)}
              key={item.id}
              className={item.id == selectedWarehouse && "bg-info"}
            >
              {item.name}
            </button>
          ))
        )}
      </div>
      <button className="py-2 px-4 mt-3 filter-btn-2" onClick={onApply}>
        اعمال فیلتر
      </button>
    </div>
  );
};

export default ProductFilterModal;
